// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3kamr","closeWrapper":"_1jjrg","close":"iQxBD","imageWrapper":"_3-oEO"};